import { camelCase, snakeCase } from 'lodash'

const convertCase = (obj: any, caseConverter: (s: string) => string): any => {
  if (Array.isArray(obj)) {
    return obj.map((v) => convertCase(v, caseConverter))
  } else if (obj instanceof Date) {
    return obj
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce(
      (prev, [key, value]) => ({
        ...prev,
        [caseConverter(key)]: convertCase(value, caseConverter),
      }),
      {}
    )
  }
  return obj
}

type ConvertType = Record<string, any>
type ConvertTarget = ConvertType | ConvertType[]

export const convertToSnakeCase = (obj: ConvertTarget): ConvertTarget => {
  return convertCase(obj, snakeCase)
}

export const convertToCamelCase = (obj: ConvertTarget): ConvertTarget => {
  return convertCase(obj, camelCase)
}

export { camelCase, snakeCase }

export const omitSensitive = <T, Key extends keyof T>(obj: T, keysToOmit: Key[]): Omit<T, Key> => {
  const clone = { ...obj }

  keysToOmit.forEach((key) => {
    delete clone[key]
  })

  return clone
}

export const leftPad = (value: number): string => {
  if (value >= 10) {
    return value.toString()
  }
  return `0${value}`
}

export const formatDateFromString = (input: string | number) => {
  const date = new Date(input)
  const year = date.getFullYear()
  const month = leftPad(date.getMonth() + 1)
  const day = leftPad(date.getDate())
  const hour = leftPad(date.getHours())
  const minutes = leftPad(date.getMinutes())

  return `${year}년 ${month}월 ${day}일 ${hour}:${minutes}`
}

export const toLowerCaseFirstChar = (str: string): string => {
  if (!str || str.length < 1) {
    return str
  }

  return str.charAt(0).toLowerCase() + str.slice(1)
}
